import type React from "react";
import { Link } from "react-router-dom";
import { useChannels } from "@/hooks/channel/useChannels";
import { useAuth } from "@/hooks/useAuth";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";
import { Alert, AlertDescription } from "@/components/ui/alert";

const ChannelListPage: React.FC = () => {
	const { channels, loading, error } = useChannels();
	const { user } = useAuth();

	if (loading) {
		return (
			<div className="space-y-4">
				<h1 className="text-3xl font-bold">チャンネル一覧</h1>
				<div className="space-y-4">
					{/* ユニークなIDを生成するためにcryptoを使用 */}
					{Array.from({ length: 4 }, () => crypto.randomUUID()).map((id) => (
						<Skeleton key={id} className="h-24 w-full" />
					))}
				</div>
			</div>
		);
	}

	if (error) {
		return (
			<Alert variant="destructive">
				<AlertDescription>
					チャンネル一覧の取得に失敗しました。
				</AlertDescription>
			</Alert>
		);
	}

	return (
		<div className="space-y-6">
			<div className="flex justify-between items-center">
				<h1 className="text-3xl font-bold">チャンネル一覧</h1>
				{user?.role === "admin" && (
					<Button>
						<Plus className="h-4 w-4 mr-2" />
						チャンネルを追加
					</Button>
				)}
			</div>

			<div className="grid gap-4">
				{channels?.map((channel) => (
					<Link
						key={channel.id}
						to={`/app/channels/${channel.id}`}
						className="block"
					>
						<div className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow">
							<div className="flex items-center space-x-3">
								<span className="text-2xl">{channel.emoji}</span>
								<div>
									<h2 className="text-xl font-semibold">{channel.name}</h2>
									<p className="text-gray-600">{channel.description}</p>
								</div>
							</div>
						</div>
					</Link>
				))}
			</div>
		</div>
	);
};

export default ChannelListPage;
